import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7 10l5.5 5.5L18 10" stroke="currentColor" fill="none" /></svg>;